export default "__VITE_ASSET__GTaL1TIZ__"